import { LocationDto } from "./location.dto";
import { ResponseDto } from "./response.dto";
import { ReviewSourceDto } from "./reviewSource.dto";

/**
 * DTO object for creation of Review.
 */
export class ReviewDto {
  id: number;
  locationId: number;
  reviewId: number;
  author: string;
  businessResponseURL: string;
  summary: string;
  content: string;
  createdDateAt: Date;
  publishedDateAt: Date;
  rating: number;
  exactRating: string;
  source: string;
  sourceId: string;
  uniqueId: string;
  url: string;
  respondable: boolean;
  permalink: string;
  reviewResponse?: ResponseDto[];
  reviewSource?: ReviewSourceDto;
  location: LocationDto;
  pieFlagged: boolean;
  pieStatus: string;
  pieLastActionDate: Date;
  pieCategory: string;
  sentiment: string;
  pieRiskCategory: string
  pieCustomerEmail: string;
  pieCustomerAddress: string;
  pieInternalNote: string;
  pieTag: string;
  pieLinkedReview: string
}
